import {
  ADD_NEW_ERROR,
  ADD_NEW_SUCCESS,
  FETCHING,
  GET_BANNER,
  VOTE_BANNER,
  POST_BANNER,
  UPDATE_BANNER,
} from '../constants/actionTypes'
import { Action } from 'redux'
import environment from '../../environment'
import { ThunkAction, ThunkDispatch } from 'redux-thunk'
import {
  BannerDataProps,
  BannerStatus,
  GETBannerDataProps,
} from '../../interfaces/banners'
const serverUrl = environment._serverUrl
export const getAllBanners =
  ({
    token,
  }: {
    token: string
  }): ThunkAction<void, GETBannerDataProps[], unknown, Action> =>
  async (
    dispatch: ThunkDispatch<GETBannerDataProps[], unknown, Action>
  ): Promise<void> => {
    dispatch({ type: FETCHING, payload: true })
    try {
      const getBanners = await fetch(serverUrl + 'admin/banners', {
        method: 'GET',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        referrerPolicy: 'no-referrer',
      })
      const status = await getBanners.status

      if (status === 200) {
        const banners = await getBanners.json()
        const formattedBanners = banners.map((banners: GETBannerDataProps) => {
          return {
            ...banners,
          }
        })

        console.log('API response:', formattedBanners)
        dispatch({ type: GET_BANNER, payload: formattedBanners })
        dispatch({ type: FETCHING, payload: false })
      } else if (status === 204) {
        dispatch({ type: ADD_NEW_ERROR, payload: '204: No banners found' })
        dispatch({ type: FETCHING, payload: false })
      } else {
        dispatch({ type: ADD_NEW_ERROR, payload: status.toString() })
        dispatch({ type: FETCHING, payload: false })
      }
    } catch (ex) {
      console.error('Error', ex)
    }
    return
  }

export const postBanner =
  ({
    token,
    banners,
  }: {
    token: string
    banners: Partial<BannerDataProps>
  }): ThunkAction<Promise<boolean>, any, unknown, Action> =>
  async (dispatch: ThunkDispatch<any, unknown, Action>): Promise<boolean> => {
    try {
      const updatedBanner = await fetch(serverUrl + 'admin/Banner', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(banners),
      })

      if (updatedBanner.ok) {
        console.log('successful')
        dispatch({ type: ADD_NEW_SUCCESS })
        return true
      } else {
        console.error('Failed', updatedBanner.status)
        dispatch({
          type: ADD_NEW_ERROR,
          payload: updatedBanner.status.toString(),
        })
        return false
      }
    } catch (ex) {
      console.error('Error', ex)
      const message = ex instanceof Error ? ex.message : 'Error'
      dispatch({ type: ADD_NEW_ERROR, payload: message || 'Error' })
      return false
    }
  }

export const voteBanner =
  ({
    token,
    bannerId,
    vote,
  }: {
    token: string
    bannerId: string
    vote: boolean
  }): ThunkAction<Promise<boolean>, any, unknown, Action> =>
  async (dispatch: ThunkDispatch<any, unknown, Action>): Promise<boolean> => {
    try {
      const votedBanner = await fetch(
        serverUrl + `admin/Banner/${bannerId}/IsApproved`,
        {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          referrerPolicy: 'no-referrer',
          body: JSON.stringify(vote),
        }
      )

      if (votedBanner.ok) {
        dispatch({ type: VOTE_BANNER, payload: votedBanner.status })
        return true
      } else {
        dispatch({
          type: ADD_NEW_ERROR,
          payload: votedBanner.status.toString(),
        })
        return false
      }
    } catch (ex) {
      console.error('Error', ex)
      const message = ex instanceof Error ? ex.message : 'Error'
      dispatch({ type: ADD_NEW_ERROR, payload: message || 'Error' })
      return false
    }
  }

export const updateBannerStatus =
  ({
    token,
    bannerId,
    status,
  }: {
    token: string
    bannerId: string
    status: BannerStatus | string
  }): ThunkAction<void, any, unknown, Action> =>
  async (dispatch: ThunkDispatch<any, unknown, Action>): Promise<void> => {
    try {
      const deletedBanner = await fetch(
        serverUrl +
          `admin/Banner/updateBannerStatus/${bannerId}?status=${status}`,
        {
          method: 'POST',
          cache: 'no-cache',
          headers: {
            'Content-Type': 'application/json',
            Authorization: token,
          },
          referrerPolicy: 'no-referrer',
        }
      )

      const success = await deletedBanner.status

      if (success) {
        dispatch({ type: ADD_NEW_SUCCESS, payload: success })
        dispatch(getAllBanners({ token }) as any)
      }
    } catch (ex) {
      console.error('Error', ex)
      const message = ex instanceof Error ? ex.message : 'Error'
      dispatch({ type: ADD_NEW_ERROR, payload: message || 'Error' })
    }
  }

export const updateBanner =
  ({
    token,
    banner,
  }: {
    token: string
    banner: Partial<BannerDataProps> & {
      id?: string
      bannerStatus?: BannerStatus | string
    }
  }): ThunkAction<Promise<boolean>, any, unknown, Action> =>
  async (dispatch: ThunkDispatch<any, unknown, Action>): Promise<boolean> => {
    try {
      const body = banner

      const updatedBanner = await fetch(serverUrl + 'admin/Banner', {
        method: 'POST',
        cache: 'no-cache',
        headers: {
          'Content-Type': 'application/json',
          Authorization: token,
        },
        referrerPolicy: 'no-referrer',
        body: JSON.stringify(body),
      })

      const success = await updatedBanner.status

      if (updatedBanner.ok) {
        dispatch({ type: ADD_NEW_SUCCESS, payload: success })
        return true
      }

      dispatch({ type: ADD_NEW_ERROR, payload: success.toString() })
      return false
    } catch (ex) {
      console.error('Error', ex)
      const message = ex instanceof Error ? ex.message : 'Error'
      dispatch({ type: ADD_NEW_ERROR, payload: message || 'Error' })
      return false
    }
  }
